// extracted by mini-css-extract-plugin
export var chevron = "_11-d";
export var disabled = "_11-b";
export var error = "_11-c";
export var hideBorder = "_11-1";
export var icon = "_11-e";
export var input = "_11-0";
export var large = "_11-f";
export var open = "_11-9";
export var placeholder = "_11-a";
export var regular = "_11-5";
export var singleRowInput = "_11-2";
export var singleSelectInput = "_11-3 _11-0";
export var small = "_11-4";
export var spinnerContainer = "_11-i";
export var tag = "_11-7";
export var tagsContainer = "_11-8";
export var tagsInput = "_11-6 _11-0";
export var xSmall = "_11-g";
export var xxSmall = "_11-h";